"use client";

import { useEffect, useRef } from "react";
import { setUserId } from "../events";

/**
 * 登录用户 id 注入 Metrica(`setUserID`)的 hook。
 *
 * - 传 `undefined` / `""`(未登录)是 no-op,所以 匿名→登录 的切换只会触发一次。
 * - 按 id 去重:同一 id 的重复 render 不会重复 setUserID。
 * - 调用方在 web/mini 各 mount 一个薄壳组件,从 `useUserInfo(token).data?.id` 取 id。
 */
export function useMetricaUserId(userId: string | undefined): void {
  const last = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (!userId) return;
    if (last.current === userId) return;
    last.current = userId;
    setUserId(userId);
  }, [userId]);
}
